
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { OrganizationService } from "src/app/Service/organization/organization.service";
import { IOrganizationViewModel } from "src/app/ViewModel/OrganizationModel";
import { ExternalMemberService } from 'src/app/Service/member/external-member.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { IDeleteDocumentInputModel, DrawingInactiveOutputModel, DrawingInactiveInputModel } from 'src/app/ViewModel/DeletedocumentModel';
import { CommonService } from 'src/app/Service/Common.service';
import { DeleteDocumentService } from 'src/app/Service/deletedocument/deletedocument.service';
import { DrawingInactiveResponseComponent } from '../Drawing-Inactive-Response/Drawing-Inactive-Response.components';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import * as moment from 'moment';

@Component({
  selector: 'app-Drawing-Inactive',
  templateUrl: './Drawing-Inactive.components.html',
  styleUrls: ['./Drawing-Inactive.components.css']
})
export class DrawingInactiveComponent implements OnInit {
  enableFilter = false;
  enableFullscreen = false;
  projectId!: number;
  groupId!: number;
  LoggedInUserGroupId!: number;
  LoggedInUserId!: number;
  public Search: string = "Search";
  public update_status!: string;
  public isAdmin: boolean = false;
  DrawingForm!: FormGroup;
  businessGroups: IOrganizationViewModel[] = [];
  disciplineList: undefined | RoleFeatureModel[] = [];
  disciplineId!: number | null;
  RevisionType: string = "1";
  clearDisciplineSelected = 'N';
  public dedId!: any;
  public pageSize = [50, 100, 200, {
    text: 'All',
    value: 'all'
  }];
  /**Members list against the business group */
  public DocumentList: DrawingInactiveOutputModel[] = [];
  constructor(private _dialog: MatDialog, private _orgService: OrganizationService, public _formBuilder: FormBuilder,
    private _extMemberService: ExternalMemberService, private _notificationService: NotificationService, public commonService: CommonService,
    public DeleteDocumentService: DeleteDocumentService, public mapRoleFeatureService: MapRoleFeatureService) {

  }
  ngOnInit() {
    this.LoggedInUserGroupId = this.commonService.getLoggedInUserGroupId();
    this.createBusinessGroupForm();
    this.projectId = this.commonService.getProjectId();
    this.LoggedInUserId = this.commonService.getLoggedInUserId();
    this.getDiscipline(this.LoggedInUserGroupId);
    this.commonService.getProjectMemberRoles(this.projectId, this.LoggedInUserGroupId, this.LoggedInUserId).subscribe(async (result: any[]) => {
      result = result.filter(x => x.role_Desc == 'ISD');
      if (result.length > 0) {
        this.isAdmin = true;
      }
    });
  }

  createBusinessGroupForm() {
    this.DrawingForm = this._formBuilder.group({
      businessGroup: new FormControl('', [Validators.required]),
      Documet_no: new FormControl(),
      Documet_title: new FormControl(),
      DocumentStatus: new FormControl(true),

    })
  }

  getDocumentList(group?: IOrganizationViewModel) {

    this.DocumentList = [];
    let obj: DrawingInactiveInputModel = {
      groupId: this.LoggedInUserGroupId,
      projectId: this.projectId,
      doc_Id: "",
      status: this.getFormValue('DocumentStatus'),
      doc_no: this.getFormValue('Documet_no'),
      doc_title: this.getFormValue('Documet_title'),
      disciplineId: this.disciplineId

    };

    this.DeleteDocumentService.GetDrawingInactiveDocumentlist(obj).subscribe((data: DrawingInactiveOutputModel[]) => {
      if (this.getFormValue('DocumentStatus'))
        this.update_status = "In Active"
      else this.update_status = "Active"
      this.DocumentList = data;
    });

  }


  UpdateAllDocument() {
    let selectedDocIds: number[] = this.DocumentList.filter(x => x.is_select).map(x => x.doc_Id);

    if (selectedDocIds && selectedDocIds.length > 0) {
      let obj: DrawingInactiveInputModel = {
        groupId: this.LoggedInUserGroupId,
        projectId: this.projectId,
        doc_Id: selectedDocIds.toString(),
        status: (this.update_status == "Active" ? true : false),
        doc_no: "",
        doc_title: "",
        userid: this.LoggedInUserId
      };
      this._notificationService.showPopup('Are you sure to ' + this.update_status + ' the selected Document', 'Confirm').then(data => {
        if (data == 'yes') {
          // let dialogRef = this.dialog.open(DciSupersedeComponent, {
          //     panelClass: 'mat-dialog-primary',
          //     data: this.schDoc,
          //     autoFocus:false
          // });
          this.DeleteDocumentService.UpdateDrawingStatus(obj).subscribe((res: DrawingInactiveOutputModel[]) => {
            this.Responce(res)
          });
        }
      });

    }
    else {
      this._notificationService.showToast("Please select Document", "Warning");
    }
  }
  UpdateDocument(Document: DrawingInactiveOutputModel) {
    let obj: DrawingInactiveInputModel = {
      groupId: this.LoggedInUserGroupId,
      projectId: this.projectId,
      doc_Id: Document.doc_Id.toString(),
      status: (this.update_status == "Active" ? true : false),
      doc_no: "",
      doc_title: "",
      userid: this.LoggedInUserId
    };
    if (!Document.is_select) {
      this._notificationService.showToast("Please select Document", "Warning");
      return;
    }
    this._notificationService.showPopup('Are you sure to ' + this.update_status + ' the selected Document', 'Confirm').then(data => {
      if (data == 'yes') {
        this.DeleteDocumentService.UpdateDrawingStatus(obj).subscribe((res: DrawingInactiveOutputModel[]) => {
          this.Responce(res)

        });
      }
    });
  }
  Responce(res: any[]) {
    let dialogRef = this._dialog.open(DrawingInactiveResponseComponent, {
      panelClass: 'mat-dialog-content',
      data: res
    });

    dialogRef.afterClosed().subscribe((data) => {
      this.getDocumentList();
    });

  }
  handleHeaderCheckboxEvent(event: any) {
    this.DocumentList.map(x => x.is_select = event.checked)
  }

  /**
* Toggle filter
*/
  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  /**
     * Full screen
     */
  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }
  change(data: any) {

  }
  getFormValue(controlName: string): any {
    return this.DrawingForm.get(controlName)?.value;
  }
  async getDiscipline(businessGroupId: number) {
    if (!businessGroupId) {
      this.disciplineList = [];
      return;
    }

    this.disciplineList = await this.mapRoleFeatureService.getDedAgainstDe("Discipline", businessGroupId, null, null, 0).toPromise();
  }
  changeDiscipline(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
    this.disciplineId = event.value != '-2' ? parseInt(event.value.toString()) : null;
  }
}
